import { useQuery } from '@gogame/query';

import { loadParentCampaigns } from 'scenes/Campaigns/sources/parentCampaigns';

import { grid } from './queryKeyFactory';

export const useLoadParentCampaigns = (params, options) => {
  return useQuery(
    grid(params),
    (_, { signal }) => loadParentCampaigns(params, { signal }),
    options
  );
};
